import { toastr } from 'react-redux-toastr'
import branditRails from '../api/brandit_rails'
import history from '../history'
import { CREATE_DOMAIN, DELETE_DOMAIN, EDIT_DOMAIN, FETCH_DOMAIN, FETCH_PORTAL_DOMAINS } from './types'

export const fetchDomain = id => async dispatch => {
  await branditRails.get(`/domains/${id}`).then(function (response) {
    dispatch({ type: FETCH_DOMAIN, payload: response.data })
  })
}

export const createDomain = formValues => async dispatch => {
  try {
    const { data } = await branditRails.post(`/domains`, formValues)
    dispatch({ type: CREATE_DOMAIN, payload: data })
    toastr.success('Create Domain', 'Domain created successfully!')
    return data
  } catch (error) {
    if (!error.response && error.code !== 'ERR_NETWORK') {
      toastr.error('Create Domain', 'The request did not complete. Please try again.')
    }
    throw error
  }
}

export const fetchPortalDomains = portal_id => async dispatch => {
  try {
    const { data } = await branditRails.request({
      url: 'mf/grid',
      method: 'GET',
      params: {
        table: 'domains',
        $orderby: 'id desc',
        $top: 10,
        $inlinecount: 'allpages',
        sql_appendix: `portal_id = ${portal_id}`,
        id_sort_order: 'desc',
        image_keys: ''
      }
    })

    dispatch({ type: FETCH_PORTAL_DOMAINS, payload: data.d.results })
  } catch {
    toastr.error('Fetch Domains', 'Unable to fetch domains. Please try again or contact support')
  }

  await branditRails.get(`/portals/${portal_id}/domains`).then(function (response) {
    dispatch({ type: FETCH_PORTAL_DOMAINS, payload: response.data })
  })
}

export const editDomain = (id, formValues) => async dispatch => {
  await branditRails.patch(`/domains/${id}`, formValues).then(function (response) {
    dispatch({ type: EDIT_DOMAIN, payload: response.data })
    toastr.success('Update Domain', 'Domain updated successfully!')
    history.back()
  })
}

export const deleteDomain = id => async dispatch => {
  try {
    await branditRails.delete(`/domains/${id}`)
  } catch (error) {
    // A timed-out synchronous deletion may have completed on the server.
    if (error.response?.status === 404) {
      // Continue so a retry removes the stale Domain from local state.
    } else {
      if (!error.response && error.code !== 'ERR_NETWORK') {
        toastr.error('Delete Domain', 'The request did not complete. Please try again.')
      }
      throw error
    }
  }
  dispatch({ type: DELETE_DOMAIN, payload: id })
  toastr.success('Deleted Domain successfully!')
}
